export const formatCurrency = (number) => {
  return new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(
    number
  );
};
